export const LOAD_OFFER_WORKFLOW_SUCCESS = "LOAD_OFFER_WORKFLOW_SUCCESS";
export const LOAD_OFFER_WORKFLOW_TASKS_SUCCESS = "LOAD_OFFER_WORKFLOW_TASKS_SUCCESS";
